import React, { Component, createRef } from "react";
import './styles.scss';
import { generateKey } from "../../../infrastructure/helpers/react/commonHelper";
import { ReactComponent as CaretDown } from '../../Common/BootstrapIcons/caret-down-fill.svg';
import { ReactComponent as CaretUp } from '../../Common/BootstrapIcons/caret-up-fill.svg';
import OutsideClickDetector from "../OutsideClickDetector";

interface Props {
    options: string[];
    onOptionSelected: (option: string) => void;
    value: string;
    onClick: () => void;
    containerClassName?: string;
}

interface State {
    selected: string;
    open: boolean;
}

class CustomDropdown extends Component<Props, State> {

    private dropdownRef = createRef<HTMLDivElement>();

    constructor(props: Props) {
        super(props);

        this.state = {
            selected: this.props.value || '',
            open: false
        }

        this.toggleDropdown = this.toggleDropdown.bind(this);
        this.selectOption = this.selectOption.bind(this);
    }

    toggleDropdown() {
        this.setState({ open: !this.state.open });
    };

    selectOption(option: string) {
        this.setState({ selected: option, open: false }, () => { this.props.onOptionSelected(option) });
    };

    render() {
        return (
            <OutsideClickDetector onClickOuside={() => this.setState({ open: false })}>
                <div className={`select-container ${this.props.containerClassName || ''}`} ref={this.dropdownRef} onClick={() => this.props.onClick()} >
                    <div className='select' onClick={this.toggleDropdown}>
                        <span className="custom-dropdown-header">
                            {this.state.selected}
                        </span>
                        {this.state.open ? <button className='caret' onClick={this.toggleDropdown}>
                            <CaretUp /></button> :
                            <button className='caret' onClick={() => this.toggleDropdown()}><CaretDown /></button>
                        }
                    </div>
                    {this.state.open &&
                        <ul className={`dropdown-list ${this.props.containerClassName || ''}`} onMouseLeave={() => this.setState({ open: false })}>
                            {this.props.options.map((option) => (
                                <li key={generateKey()}
                                    className="dropdown-option"
                                    onClick={() => this.selectOption(option)}
                                >
                                    {option}
                                </li>
                            ))}
                        </ul>
                    }
                </div>
            </OutsideClickDetector>
        );
    }
}

export default CustomDropdown;